import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'

export class CometCompetitionApiService extends ApiService {
  static async getAll(): Promise<AxiosResponse> {
    return this.axios.get('comet-competitions')
      .then((response: AxiosResponse) => response.data)
  }

  static async create(data: object): Promise<AxiosResponse> {
    return this.axios.post('comet-competitions', data)
      .then((response: AxiosResponse) => response.data)
  }

  static async update(id: number, data: object): Promise<AxiosResponse> {
    return this.axios.put(`comet-competitions/${id}`, data)
      .then((response: AxiosResponse) => response.data)
  }

  static async delete(id: number): Promise<AxiosResponse> {
    return this.axios.delete(`comet-competitions/${id}`)
      .then((response: AxiosResponse) => response.data)
  }
}
